export const MANAGER_ACL = {
  manager: 100,
  orgManager: 100,
  orgSupervisor: 200,
  orgRegionalSupervisor: 300
}
